import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Lightbulb, Target, CheckCircle2, ArrowRight } from 'lucide-react';
export function KnoogetsSection() {
  const components = [{
    icon: <FileText size={24} data-id="element-112" />,
    title: 'Documentation',
    desc: 'Structured, searchable foundational knowledge.'
  }, {
    icon: <Lightbulb size={24} data-id="element-113" />,
    title: 'Learning Knoogets',
    desc: 'Bite-sized insight capsules designed for rapid absorption.'
  }, {
    icon: <Target size={24} data-id="element-114" />,
    title: 'Challenges',
    desc: 'Action-oriented experiments to apply knowledge immediately.'
  }];
  const capabilities = ['Rapid onboarding', 'Continuous learning loops', 'Experiment-driven innovation', 'Knowledge retention at scale'];
  return <section className="py-24 bg-gray-50" data-id="element-115">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-117">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-118">
            <h2 className="text-teal-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-119">
              Execution Layer
            </h2>
            <h3 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-120">
              Knoogets Toolkit
            </h3>
            <p className="text-xl text-gray-900 font-medium mb-6" data-id="element-121">
              From information to insight. From insight to action.
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-122">
              Knoogets are modular knowledge units designed to accelerate
              learning and execution. Think of them as the building blocks of a
              living intelligence system.
            </p>

            <div className="space-y-4 mb-8" data-id="element-123">
              <h4 className="font-bold text-gray-900" data-id="element-124">What they enable:</h4>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-125">
                {capabilities.map((cap, idx) => <li key={idx} className="flex items-center gap-2 text-gray-700" data-id="element-126">
                    <CheckCircle2 size={18} className="text-teal-600" data-id="element-127" />
                    <span data-id="element-128">{cap}</span>
                  </li>)}
              </ul>
            </div>

            <button className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-129">
              Explore Knoogets
              <ArrowRight size={18} data-id="element-130" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-131">
            {components.map((comp, idx) => <div key={idx} className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex gap-4 items-start hover:border-amber-500 transition-colors" data-id="element-132">
                <div className="p-3 bg-amber-50 text-amber-600 rounded-lg shrink-0" data-id="element-133">
                  {comp.icon}
                </div>
                <div data-id="element-134">
                  <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-135">
                    {comp.title}
                  </h4>
                  <p className="text-gray-600" data-id="element-136">{comp.desc}</p>
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}